export default {
  RequestSendExecution:
    "<b>{#SenderName#}</b> đã đề nghị bạn xem xét đề xuất <b>{#RequestExecutionName#}</b>",

  // Đồng ý đề xuất
  RequestApprovedAuthor:
    "<b>{#SenderName#}</b> đã đồng ý và chuyển tiếp đề xuất <b>{#RequestExecutionName#}</b> của bạn",
  RequestApprovedRelatedUser:
    "<b>{#SenderName#}</b> đã đồng ý và chuyển tiếp đề xuất <b>{#RequestExecutionName#}</b>",
  RequestApprovedApprover:
    "<b>{#SenderName#}</b> đã đề nghị bạn xem xét đề xuất <b>{#RequestExecutionName#}</b>",

  // Đồng ý và kết thúc
  RequestFinishAuthor:
    "<b>{#SenderName#}</b> đã đồng ý và hoàn tất đề xuất <b>{#RequestExecutionName#}</b> của bạn",
  RequestFinishRelatedUser:
    "<b>{#SenderName#}</b> đã đồng ý và hoàn tất đề xuất <b>{#RequestExecutionName#}</b>",

  // Từ chối đề xuất
  RequestRejectAndBackAuthor:
    "<b>{#SenderName#}</b> đã từ chối và trả đề xuất <b>{#RequestExecutionName#}</b> về cho bạn",
  RejectAndBackRelatedUser:
    "<b>{#SenderName#}</b> đã từ chối và trả đề xuất <b>{#RequestExecutionName#}</b> về cho <b>{#ApproverName#}</b>",
  RequestRejectedAuthor:
    "<b>{#SenderName#}</b> đã từ chối và trả đề xuất <b>{#RequestExecutionName#}</b> về cho <b>{#ApproverName#}</b>",
  RequestRejectedRelatedUser:
    "<b>{#SenderName#}</b> đã từ chối và trả đề xuất <b>{#RequestExecutionName#}</b> về cho <b>{#ApproverName#}</b>",

  RequestRejectedApprover:
    "<b>{#SenderName#}</b> đã từ chối và trả đề xuất <b>{#RequestExecutionName#}</b> về cho bạn",

  RequestRejectAndFinishAuthor:
    "<b>{#SenderName#}</b> đã từ chối và kết thúc đề xuất <b>{#RequestExecutionName#}</b> của bạn",

  RequestRejectAndFinishRelatedUser:
    "<b>{#SenderName#}</b> đã từ chối và kết thúc đề xuất <b>{#RequestExecutionName#}</b>",
  // Hủy bỏ
  RequestCancel:
    "<b>{#SenderName#}</b> đã hủy đề xuất <b>{#RequestExecutionName#}</b>",

  // Chỉnh sửa đề xuất
  RequestChangeAuthor:
    "<b>{#SenderName#}</b> đã sửa thông tin <b>{#InputName#}</b> trong đề xuất <b>{#RequestExecutionName#}</b> của bạn",
  RequestChangeRelatedUser:
    "<b>{#SenderName#}</b> đã sửa thông tin <b>{#InputName#}</b> trong đề xuất <b>{#RequestExecutionName#}</b>",

  // Comment
  RequestCommentAuthor:
    "<b>{#SenderName#}</b> đã thêm bình luận trong đề xuất <b>{#RequestExecutionName#}</b> của bạn",
  RequestCommentAuthorGroup: {
    SINGLE:
      "<b>{#SenderName#}</b> đã thêm bình luận trong đề xuất <b>{#RequestExecutionName#}</b> của bạn",
    MULTI:
      "<b>{#SenderName#}</b> và <b>{#OtherUserCount#}</b> người khác đã thêm bình luận trong đề xuất <b>{#RequestExecutionName#}</b> của bạn"
  },
  RequestCommentRelatedUser:
    "<b>{#SenderName#}</b> đã thêm bình luận trong đề xuất <b>{#RequestExecutionName#}</b>",
  RequestCommentRelatedUserGroup: {
    SINGLE:
      "<b>{#SenderName#}</b> đã thêm bình luận trong đề xuất <b>{#RequestExecutionName#}</b>",
    MULTI:
      "<b>{#SenderName#}</b> và <b>{#OtherUserCount#}</b> người khác đã thêm bình luận trong đề xuất <b>{#RequestExecutionName#}</b>"
  },
  RequestTagComment:
    "<b>{#SenderName#}</b> đã nhắc đến bạn trong một bình luận thuộc đề xuất <b>{#RequestExecutionName#}</b>",
  // người liên quan
  RequestRelatedUserAdd:
    "<b>{#SenderName#}</b> đã thêm bạn là <b>{#InputName#}</b> trong đề xuất <b>{#RequestExecutionName#}</b>",
  RequestRelatedUserRemove:
    "<b>{#SenderName#}</b> đã xóa bạn khỏi danh sách <b>{#InputName#}</b> trong đề xuất <b>{#RequestExecutionName#}</b>",
  /// Loại đề xuất
  RequestAddRequestGroup:
    "<b>{#SenderName#}</b> đã thêm nhóm đề xuất <b>{#RequestGroupName#}</b>",
  RequestRemoveRequestGroup:
    "<b>{#SenderName#}</b> đã xóa nhóm đề xuất <b>{#RequestGroupName#}</b>",
  RequestAddRequestCategory:
    "<b>{#SenderName#}</b> đã thêm loại đề xuất <b>{#RequestCategoryName#}</b>",
  RequestRemoveRequestCategory:
    "<b>{#SenderName#}</b> đã xóa loại đề xuất <b>{#RequestCategoryName#}</b>",

  /// Phân công lại
  RequestReassignmentApproved:
    "<b>{#SenderName#}</b> đã phân công lại cho bạn thực hiện 1 đề xuất",
  RequestReassignmentWaiting:
    "<b>{#SenderName#}</b> đã hủy đề nghị xem xét đề xuất <b>{#RequestExecutionName#}</b>",

  /// Nhắc lịch duyệt
  RequestRemindWaiting: "Bạn có 1 đề xuất cần thực hiện sắp hết hạn"
};
